<template>
    <div id="sms-chat" class="d-flex flex-column">
        <InputSearchConversation
            :searchCountResult="CountsearchResult"
            :elemHighlighted="elemHighlighted"
            :currentSection="currentSection"
            :arrowBtnActivated="arrowBtnActivated"
            :resetSearch="resetSearch"
            :pageName="pageName"
            :showContactInfoSection="showContactInfoSection"
            v-on:searchChange="txtSearchChange($event, {})"
            v-on:searchClear="deleteHighlightText($event, {})"
            v-on:nextResultClick="nextResultClick($event, {})"
            v-on:previousResultClick="previousResultClick($event, {})"
        ></InputSearchConversation>
        <div class="loading-active-conversatio-box content d-flex justify-content-center" v-if="loading">
            <span class="spinner spinner-border text-primary align-self-center"></span>
        </div>
        <div class="content d-flex flex-column pt-0 justify-content-end" v-else>
            <output
                id="load-more-conversations"
                class="align-self-center fs-12 text-black"
                v-if="loadMoreLoading">
                {{ $t('loading-history') }}
            </output>
            <div
                id="conversationsSection"
                class="conversations-section mt-0"
                :class="{
                    'wihout-dashboard': !showDashboard,
                    'wihout-dashboard': !showDashboard
                }"
                v-scroll="infiniteScrollOpposite"
            >
                <div class="conversation" v-for="conversation in conversations" :key="conversation.id">
                    <div v-for="(message, index) in conversation.messages"
                        :key="message.id"
                        class="message"
                        :class="{
                            'user-message text-right': message.attributes.direction === 'mobile_terminated',
                            'contact-message text-left': message.attributes.direction === 'mobile_originated'
                        }"
                    >
                        <div
                            v-if="isMms"
                            class="mb-3"
                            :class="{
                                'right-message': message.attributes.direction === 'mobile_terminated',
                                'left-message':  message.attributes.direction === 'mobile_originated'
                            }
                        ">
                            <div class="d-flex justify-content-end">
                                <p :class="{
                                        'animated': index == contactConversations.relationships.messages.data.length - 1,
                                        'mass-message': message.attributes['is-mass'],
                                        'flash-message': message.attributes['is-flash'],
                                        'auto-response-message': message.attributes['is-auto-response'],
                                    }">
                                    <img src="/images/mms.svg">
                                </p>
                            </div>
                            <small>
                                <span v-if="message.attributes['is-mass']"> {{ $t('massive-send') }}: </span>
                                <span v-if="message.attributes['is-flash']"> {{ $t('flash-message') }}: </span>
                                <span v-if="message.attributes['is-auto-response']"> {{ $t('auto-response') }}: </span>
                                {{ formatDate(moment(message.attributes['created-at'])) }}
                            </small>
                        </div>
                        <div v-else class="mb-3" :class="{
                                'right-message': message.attributes.direction === 'mobile_terminated',
                                'left-message': message.attributes.direction === 'mobile_originated'
                            }">
                            <div class="d-flex justify-content-end">
                                <p class="text-message" :class="{
                                        'animated': index == conversation.messages.length - 1,
                                        'mass-message': message.attributes['is-mass'],
                                        'flash-message': message.attributes['is-flash'],
                                        'auto-response-message': message.attributes['is-auto-response'],
                                    }">
                                    {{ message.attributes.content }}
                                </p>
                            </div>
                            <small class="message-date">
                                <span v-if="message.attributes['is-mass']"> {{ $t('massive-send') }}: </span>
                                <span v-if="message.attributes['is-flash']"> {{ $t('flash-message') }}: </span>
                                <span v-if="message.attributes['is-auto-response']"> {{ $t('auto-response') }}: </span>
                                {{ formatDate(moment(message.attributes['created-at'])) }}
                            </small>
                        </div>
                    </div>
                    <div v-if="conversation.messages && conversation.attributes['ended-at']" class="conversation-end">
                        <p>
                            {{ $t('conversation-terminated') }} {{ formatDate(moment(conversation.attributes['updated-at'])).toLowerCase() }}
                            <span v-if="users && conversation.relationships.users.data[0] && users[conversation.relationships.users.data[0].id]">
                                {{ $i18n.t('by') }}
                                {{ users[conversation.relationships.users.data[0].id].attributes['first-name'] }}
                                {{ users[conversation.relationships.users.data[0].id].attributes['last-name'] }}
                            </span>
                        </p>
                    </div>
                    <!-- div class="conversation-end d-flex align-items-center">
                        <div class="line"></div>
                        <p>
                            {{ $t('conv-ended-automatically') }} {{ fromUtc(moment(conversation.attributes['updated-at'])).date.toLowerCase()  }}
                        </p>
                        <div class="line"></div>
                    </div -->
                </div>
            </div>
            <div class="dashboard w-100 mx-0" v-if="showDashboard">
                <div>
                    <form>
                        <select-dropdown
                            :options="options"
                            :selected="selectedTemplate"
                            v-on:selectTemplate="chooseTemplate($event)"
                            :showLabel="false"
                            :type="'template'"
                            :isDisabled="isFormDisabled">
                        </select-dropdown>
                        <textarea
                            class="form-control mt-2 select-template"
                            name="message"
                            id="message"
                            cols="30"
                            rows="4"
                            :placeholder="isFormDisabled ? chatPlaceholder : $t('write-your-response')"
                            v-model="smsText"
                            :disabled="isFormDisabled"
                            :class="{'disabled-textarea': isFormDisabled}"
                            @keyup="disabled = (smsText === '')"
                        >
                        </textarea>
                        <sms-counter :sms="smsText" v-on:limitExceeded="smsLimitExceeded = $event" v-if="!isFormDisabled"></sms-counter>
                    </form>
                </div>
                <div class="row mt-3">
                    <div class="col-6 text-left pl-3 pt-md-0 pt-2"
                        :key="contactActiveConversation.id"
                        v-if="contactActiveConversation && currentUserCanChatWithContact"
                        id="terminate-conversation"
                    >
                        <router-link :to="{ name: '' }" @click.native="terminateSingleContactConversation()"
                            v-if="this.numberToActivate === null"
                            class="text-left text-danger end-discussion-text">
                            {{ $t('end-the-conversation') }}
                        </router-link>
                    </div>
                    <div v-bind:class="[ (contactActiveConversation && currentUserCanChatWithContact) ? 'col-6' : 'col-12' ]" class="text-right">
                        <button
                            class="btn btn-primary btn-paper-plane style-btn style-btn"
                            @click="sendSms()"
                            :disabled="isButtonDisabled"
                        >
                            <font-awesome-icon class="paper-plane" :icon="['fas', 'paper-plane']" v-if="!sendingSms"/>
                            <span class="spinner-border spinner-border" role="status" aria-hidden="true" v-if="sendingSms"></span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="d-flex justify-content-end my-2" v-else>
                <div class="mr-5" >
                    <span class="initials fs-10 pointer" v-popover.top="{ name: 'active-user' }">
                        {{ userInitials }}
                    </span>
                    <img class="icone-message mb-4" src="@/core/assets/images/icon-message.png" alt="">
                </div>
            </div>
        </div>
    </div>
</template>
<script>

// Components
import SelectDropdown from '../../../core/components/SelectDropdown.vue';
import SmsCounter     from './SmsCounter.vue';
import InputSearchConversation     from './InputSearchConversation.vue';

// Internal services js
import {
    mapState, mapActions, mapGetters
} from 'vuex';
import Format from '@/helpers/Format.js';
import Alert  from '@/helpers/Alert.js';
import SearchSmsMixin    from '@/core/mixins/SearchSmsMixin';
import InfiniteScrollMixin    from '@/core/mixins/InfiniteScrollMixin';

// External services js
import HttpStatus from 'http-status-codes';
import moment     from 'moment';

export default {
    components: {
        SelectDropdown, SmsCounter, InputSearchConversation
    },

    mixins: [SearchSmsMixin, InfiniteScrollMixin],

    props: {
        currentSection: {
            default: '',
            type:    String
        },
        pageName: {
            default: '',
            type:    String
        },
        resetSearch: {
            default: false,
            type:    Boolean
        },
        loadTerminatedConversations: {
            default: true,
            type:    Boolean
        },
        showContactInfoSection: {
            default: true,
            type:    Boolean
        },
        showDashboard: {
            default: true,
            type:    Boolean
        },
        loadConversationlessMessages: {
            default: false,
            type:    Boolean
        }
    },

    data () {
        return {
            selectedTemplate: this.$i18n.t('choose-template'),
            smsMessage:       '',
            selectFilter:     this.$i18n.t('all'),
            smsLimitExceeded: false,
            smsFilter:        [
                'all',
                'last-7-days',
                'active-conversation'
            ],
            smsText:  '',
            disabled: true,
            isMms:    false,
            options:  [],

            conversationsPage:            0,
            conversationsPageTotal:       0,
            currentConversationId:        null,
            currentConversationPage:      0,
            currentConversationPageTotal: 0,

            messagesPageSize:    20,
            messagesPageTimeout: null,

            // Loadings
            loading:         false,
            sendingSms:      false,
            loadMoreLoading: false,
            messagesLoaded:  0
        };
    },

    watch: {
        smsText (newValue) {
            if (!newValue) {
                this.selectedTemplate = this.$i18n.t('choose-template');
                this.disabled         = true;
            }
        }
    },

    computed: {
        keywords () {
            return this.words.split(' ');
        },

        /**
         * Check if the send form is disabled
         *
         * @retun   {boolean}
         */
        isFormDisabled () {
            return (!this.isSubscribed ||
                !this.numberGetter ||
                this.numberToActivate ||
                this.contact.attributes['deleted-at'] !== null ||
                (this.contactActiveConversation && !this.currentUserCanChatWithContact)
            );
        },

        /**
         * Get the Chat placeholder
         *
         * @return {string}
         */
        chatPlaceholder () {
            if (!this.isSubscribed) {
                return this.$i18n.t('stop-request-received');
            } else if (this.numberToActivate) {
                return this.$i18n.t('phone-not-activated-yet');
            } else if (!this.numberGetter) {
                return this.$i18n.t('no-phone-number-configured');
            } else if (this.contact.attributes['deleted-at'] !== null) {
                return this.$i18n.t('archived-contact');
            }

            return this.$i18n.t('conversation-assigned-to-user', {
                name: this.currentConversationUser ?
                    `${this.currentConversationUser.attributes['first-name']} ${this.currentConversationUser.attributes['last-name']}` :
                    ''
            });
        },

        /**
         * Check if the send button is disabled
         *
         * @retun   {boolean}
         */
        isButtonDisabled () {
            return (
                !this.isSubscribed ||
                !this.numberGetter ||
                this.disabled ||
                this.sendingSms ||
                this.smsLimitExceeded ||
                (this.contactActiveConversation && !this.currentUserCanChatWithContact)
            );
        },

        /**
         * State of SMS conversation
         *
         */
        ...mapState('core/conversations', {
            contactHasConversations:   'contactHasConversations',
            contactActiveConversation: 'contactActiveConversation',
            contactConversations:      'contactConversations'
        }),

        /**
         * State for current active conversation with the current contact
         * Single contact
         * Conversations
         */
        ...mapState('core/contacts', { contact: 'single' }),

        /**
         * State of tenant
         *
         * selectedTenant    State of the tenant the user has selected
         */
        ...mapState('core/tenants', { selectedTenant: 'selectedTenant' }),

        /**
         * State of templates
         * templates    State of all templates
         */
        ...mapState('core/templates', [
            'templates'
        ]),

        /**
         * State of SMS messages
         * messages    State of all SMS messages
         */
        ...mapState('core/sms-messages', [
            'messages',
            'messagesUsers'
        ]),

        /**
         * Getters for conversations
         */
        ...mapGetters('core/conversations', [
            'isSubscribed',
            'currentUserCanChatWithContact',
            'currentConversationUser'
        ]),

        // Getter for the selected phone number
        ...mapGetters('core/number', { numberGetter: 'smsPhoneNumber', numberToActivate: 'numberToActivate' }),

        /**
         * Get the current conversation active user initials
         */
        userInitials () {
            if (this.currentConversationUser) {
                return this.currentConversationUser.attributes['first-name'].charAt(0).toUpperCase() + this.currentConversationUser.attributes['last-name'].charAt(0).toUpperCase();
            }

            return null;
        },

        /**
         * Get the conversations
         */
        conversations () {
            // Get conversations from store
            const conversations = this.contactConversations.conversations;

            // Check if conversationless messages are loaded
            if (!this.messages) {
                return Object.values(conversations).sort((a, b) => new Date(b.attributes['created-at']) - new Date(a.attributes['created-at']));
            }

            // Map conversationless messages as conversations
            const conversationlessMessages = Object.values(this.messages);
            const conversationlessConversations = {};

            conversationlessMessages.forEach((message) => {
                conversationlessConversations[`conversationless-${message.id}`] = {
                    id:         `conversationless-${message.id}`,
                    attributes: {
                        'created-at': message.attributes['created-at'],
                        'updated-at': message.attributes['updated-at'],
                        'ended-at':   null
                    },
                    messages:      [message],
                    relationships: {
                        users: { data: [message.relationships.user.data] }
                    }
                };
            });

            let arrayConversations = Object.values({ ...conversationlessConversations, ...conversations });
            arrayConversations = arrayConversations.sort((a, b) => new Date(b.attributes['created-at']) - new Date(a.attributes['created-at']));
            return arrayConversations;
        },

        /**
         * Get the users
         */
        users () {
            return { ...this.contactConversations.users, ...this.messagesUsers };
        }
    },

    mounted () {
        this.getConversationsDetails();

        // Listen to the websocket event.
        if (this.loadTerminatedConversations) {
            this.update({ tenantId: this.selectedTenant.id, filters: {} });
        }

        this.getTemplate().then(() => {
            this.options.push({
                'id':      null,
                'name':    this.$i18n.t('choose-template'),
                'content': ''
            });
            for (const templateId in this.templates) {
                this.options.push({
                    'id':      templateId,
                    'name':    this.templates[templateId].attributes.name,
                    'content': this.templates[templateId].attributes.content
                });
            }
        });
    },

    methods: {
        /**
         * Methods for SMS API requests
         */
        ...mapActions('core/sms-messages', {
            newSms:      'create',
            getMessages: 'index'
        }),

        /**
         * Load templates
         */
        ...mapActions('core/templates', { getTemplate: 'index' }),

        /**
         * SetActiveContact      set the active contact
         * terminateConversation ends a conversation
         *
         */
        ...mapActions('core/conversations', [
            'getContactConversations',
            'getConversationMessages',
            'setActiveContact',
            'terminateConversation',
            'resetSingleConversation',
            'stopListeningToWebsocket',
            'update'
        ]),

        /**
         * Define moment to use it in template
         */
        moment,

        /**
         * Fetch conversation details
         */
        getConversationsDetails () {
            this.loading = true;

            // Init the conversation board and then load new data
            this.resetSingleConversation();
            this.setActiveContact({ contactId: this.contact.id });

            // Load first conversation
            this.loadNextConversation(false);

            // Load conversationless messages
            if (this.loadConversationlessMessages) {
                this.getMessages({
                    filters: {
                        'conversationless': 1,
                        'to':               this.contact.attributes['phone-number'].replace('+', '')
                    },
                    include: 'user'
                });
            }
        },

        /**
         * Load next conversation
         */
        async loadNextConversation (append) {
            let filters  =  {};
            if (!this.loadTerminatedConversations) {
                filters = { 'is-active': 1 };
            }

            // Load next conversation
            this.conversationsPage += 1;

            this.getContactConversations({
                id:   this.contact.id,
                append,
                page: {
                    size:   1,
                    number: this.conversationsPage
                },
                filters
            }).then(async (response) => {
                this.conversationsPageTotal = response.meta.page['last-page'];

                // Load the messages for the first conversation
                if (response.data.conversations === undefined) {
                    this.loading = false;
                    return;
                }

                const conversations = Object.values(response.data.conversations);
                if (conversations.length === 0) {
                    this.loading = false;
                    return;
                }

                // Load conversations until we fill the page
                await this.loadConversationMessages(conversations[0]);

                // Stop if we filled the page
                if (this.messagesLoaded >= this.messagesPageSize) {
                    this.loading = false;
                    this.enableInfiniteScroll();
                    return;
                }

                // If we never reached the page size, loading is done, but do not enable infinite scroll
                const timeout = 500;
                this.messagesPageTimeout = setTimeout(() => {
                    this.loading = false;
                }, timeout);
            });
        },

        /**
         * Fill page with conversations
         */
        async loadConversationMessages (conversation) {
            this.currentConversationId   = conversation.id;
            this.currentConversationPage = 1;

            await this.getConversationMessages({
                conversationId: conversation.id,
                append:         false,
                page:           {
                    size:   this.messagesPageSize,
                    number: 1
                }
            })
                .then((response) => {
                    this.messagesLoaded += Object.values(response.data.messages).length;
                    this.currentConversationPageTotal = response.meta.page['last-page'];

                    // If we still have space in the page, load next conversation
                    if (this.messagesLoaded < this.messagesPageSize && this.conversationsPage < this.conversationsPageTotal) {
                        this.loadNextConversation(true, 'loadConversationMessages');
                    }
                });
        },

        /**
         * Update selected option
         *
         * @return    void
         */
        chooseTemplate (option) {
            if (option.id === null) {
                this.selectedTemplate = option.name;
                this.disabled = option.id === null;
            } else if (this.smsText === '') {
                this.selectedTemplate = option.name;
                this.smsText = option.content;
                this.disabled = option.id === null;
            } else {
                Alert.confirmation(this.$i18n.t('this-will-replace-message'), this.$i18n.t('replace'))
                    .then((response) => {
                        if (response.isConfirmed) {
                            this.selectedTemplate = option.name;
                            this.smsText = option.content;
                        }
                    });
            }
        },

        /**
         * Send sms to contact
         */
        sendSms () {
            if (this.isButtonDisabled) {
                return;
            }

            this.sendingSms = true;
            this.newSms({
                phoneNumber: this.contact.attributes['phone-number'],
                sms:         this.smsText
            })
                .then(async () => {
                    this.smsText = '';
                    Alert.success(this.$i18n.t('message-sent'));
                    this.$emit('conversationUpdated');
                })
                .catch((errors) => {
                    if (errors.response && errors.response.status === HttpStatus.UNPROCESSABLE_ENTITY) {
                        Alert.fail((errors.response.data.errors[0].detail));
                    }
                })
                .finally(() => {
                    this.sendingSms = false;
                    const container = document.querySelector('#conversationsSection');
                    container.scrollTop = container.scrollTo(0, container.scrollHeight);
                    this.disabled = true;
                });
        },

        /**
         * Terminate conversation
         */
        terminateSingleContactConversation () {
            Alert.confirmation(this.$i18n.t('end-the-conversation'), this.$i18n.t('terminate'))
                .then((result) => {
                    if (result.isConfirmed) {
                        this.terminateConversation({ id: this.contactActiveConversation.id })
                            .then(() => {
                                this.$emit('conversationTerminated');
                            });
                    }
                });
        },

        /**
         * Infinite scroll end reached callback from infinite scroll mixin.
         *
         * @param {number} page The page number reached.
         */
        infiniteScrollEndReached (page) {
            console.log('infiniteScrollEndReached');

            // Disable the infinite scroll when the user reaches the end
            this.disableInfiniteScroll();
            this.currentConversationPage = page;

            // Load next conversation messages page
            const loadMoreTimer = 500;
            if (this.currentConversationPage < this.currentConversationPageTotal) {
                this.loadMoreLoading = true;
                this.currentConversationPage++;

                this.getConversationMessages({
                    conversationId: this.currentConversationId,
                    append:         true,
                    page:           {
                        size:   this.messagesPageSize,
                        number: this.currentConversationPage
                    }
                }).then(() => {
                    setTimeout(() => {
                        this.loadMoreLoading = false;
                        this.enableInfiniteScroll();
                    }, loadMoreTimer);
                });
            } else if (this.conversationsPage < this.conversationsPageTotal) {
                // Load next conversation
                this.loadMoreLoading = true;
                this.currentConversationPage = 1;

                this.loadNextConversation(true).then(() => {
                    setTimeout(() => {
                        this.loadMoreLoading = false;
                        this.enableInfiniteScroll();
                    }, loadMoreTimer);
                });
            }
        },

        /**
         * Define formatDate method to be used in template
         */
        formatDate: Format.formatDate,

        /**
         * Helper method to format date to use in template
         */
        fromUtc: Format.fromUtc
    },

    destroyed () {
        this.resetSingleConversation();
        if (this.loadTerminatedConversations) {
            this.stopListeningToWebsocket(this.selectedTenant.id);
        }
    }
};
</script>
